import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "propercase",
})
export class ProperNameCasePipe implements PipeTransform {
  transform(value: string): string {
    return value
      .toLowerCase()
      .split(" ")
      .map((word) => {
        if (["ii", "iii", "iv", "v"].includes(word.toLowerCase())) {
          return word.toUpperCase();
        } else {
          return word.charAt(0).toUpperCase() + word.slice(1);
        }
      })
      .join(" ");
  }
}
